import { guideConfig } from '@/assets/js/guide/data'
import { highLight, defineSteps } from '@/plugins/highLight'
import bus from '@/util/useBus'
import { nextTick } from 'vue'
import { getGuide as getGuideApi, updateGuide as updateGuideApi } from '@/apis/guide'
import type { Commit, Dispatch } from 'vuex'
import { isJA } from '..'
// 触发状态
const data = {
  'guide-pure-all': false,
  'guide-market-all': false,
  'guide-channel-all': false,
  'b2b-order-list': false,
  'd2c-order-list': false,
  'b2b-order': false,
  'd2c-order': false,
  'create-cssociated': false,
  'stock-list': false,
  'b2b-oem-list': false,
  'd2c-oem-list': false,
  'b2b-shopcart': false,
  'd2c-shopcart': false,
  'cssociated-product': false,
  'usercenter-b2b': false,
  'usercenter-d2c': false,
  'sync-order': false,
  'create-shipping': false,
  'combined-goods': false,
  'shipping-list': false,
  'replenishment-list': false,
  'abnormal-order': false,
  'b2b-recharge': false, // 银行卡快捷支付用户引导
  'd2c-recharge': false, // 银行卡快捷支付用户引导
  'estimate-price': false
}

export default {
  namespaced: true,
  state: {
    // 触发引导的状态
    guideState: { ...data },
    // 引导模式组件内容标记
    guideModeFlag: {
      // '111'
      // https://ckbs-static.oss-cn-hangzhou.aliyuncs.com/client-static/guide/test-img-1.png
    },
    // 数据是否已请求
    isUpdateData: false
  },
  getters: {},
  mutations: {
    UPDATE_STATE: (state: any, { key, value }: { key: string, value: any }) => {
      state[key] = value
    },
    // 重置引导状态
    RESET_GUIDE_STATE: (state: any) => {
      state.guideState = { ...data }
      state.isUpdateData = false
    },
    // 更新引导状态
    UPDATE_GUIDE_STATE: (state: any, key: string) => {
      state.guideState[key] = true
    }
  },
  actions: {
    // 重置状态
    resetGuide: ({ commit, dispatch, state, rootState }: { commit: Commit, dispatch: Dispatch, state: any, rootState: any }) => {
      commit('RESET_GUIDE_STATE')
      dispatch('updateGuide')
    },
    changeGuideStatus: ({ commit, dispatch, state, rootState }: { commit: Commit, dispatch: Dispatch, state: any, rootState: any }, { key, value }: { key: string, value: any }) => {
      const data: any = {
        ...state.guideState
      }
      data[key] = value
      commit('UPDATE_STATE', {
        key: 'guideState', value: data
      })
      dispatch('updateGuide')
    },
    openGuide: ({ commit, dispatch, state, rootState }: { commit: Commit, dispatch: Dispatch, state: any, rootState: any }, { guideKey }: { guideKey: string }) => {
      rootState.route.promise.then(() => {
        nextTick(() => {
          if (!rootState.route.token) {
            return
          }
          // 只有日本站有新手引导
          if (!isJA()) {
            bus.emit('membership', 'membership-dialog-show')
            return
          }
          if (state.isUpdateData) {
            dispatch('showGuide', { guideKey })
          } else {
            dispatch('getGuide', { customerId: rootState?.route?.user?.customerId }).then(() => {
              dispatch('showGuide', { guideKey })
            })
          }
        })
      })
    },
    // 获取账号已触发的引导
    getGuide: ({ commit, dispatch, state }: { commit: Commit, dispatch: Dispatch, state: any }, { customerId }: { customerId: any }) => {
      return new Promise<void>((resolve, reject) => {
        nextTick(() => {
          // TODO:规避customerId不存在情况
          customerId && getGuideApi({ customerId }).then(res => {
            if (!res.success) {
              reject(new Error())
              return
            }
            commit('UPDATE_STATE', { key: 'isUpdateData', value: true })
            if (res.success && res.data?.guideProperties && res.data?.guideProperties !== '') {
              commit('UPDATE_STATE', { key: 'guideState', value: { ...state.guideState, ...JSON.parse(res.data.guideProperties) } })
              // const parseJSONData = JSON.parse(res.data.guideProperties)
              // const keyList = Reflect.ownKeys(parseJSONData)
              // const guideProperties: any = {}
              // keyList.forEach(key => {
              //   guideProperties[key] = false
              // })
              // commit('UPDATE_STATE', { key: 'guideState', value: { ...state.guideState, ...guideProperties } })
            }
            resolve()
          })
        })
      })
    },
    // 更新账号的引导
    updateGuide: ({ commit, state, rootState }: { commit: Commit, state: any, rootState: any }) => {
      const formData = {
        customerId: rootState.route.user?.customerId,
        guideProperties: JSON.stringify(state.guideState)
      }
      updateGuideApi(formData)
    },
    // 显示引导
    showGuide: ({ commit, dispatch, state, rootState }: { commit: Commit, dispatch: Dispatch, state: any, rootState: any }, { guideKey, localTrigger }: { guideKey: string, localTrigger?: boolean }) => {
      if (state.guideState[guideKey] !== false && !localTrigger) {
        return
      }
      if (guideKey === 'guide-createShop-all' && !state.guideState['guide-pure-all']) {
        return
      }
      if (state.guideState['guide-pure-all'] || state.guideState['guide-createShop-all']) {
        return
      }
      const guideObj = guideConfig[guideKey]
      if (!guideObj) {
        return
      }
      if (guideObj.config.plat !== 'all' && guideObj.config.plat !== rootState.route.plat) {
        return
      }
      defineSteps(guideObj.list, {
        isSkip: guideObj.config.isSkip,
        beforeGuide: () => {
          guideObj.config.beforeGuide && guideObj.config.beforeGuide()
        },
        nextCallback: (index: any) => {
          guideObj.config.nextCallback && guideObj.config.nextCallback(index)
        },
        skipCallback: () => {
          guideObj.config.skipCallback && guideObj.config.skipCallback()
          commit('UPDATE_GUIDE_STATE', guideKey)
          dispatch('updateGuide')
          // 新人指引点击 '我知道了'，显示加入会员弹窗
          if (guideKey === 'guide-pure-all') {
            bus.emit('membership', 'membership-dialog-show')
          }
        }
      })
    }
  }
}
